module.exports = __webpack_public_path__ + "img/42.8891959f.png";